import * as React from "react";
import { Context } from "@grandvisionhq/carts-v2";
import { useLocation, useLink } from "@grandvisionhq/frk-routing";
import { useApolloClient } from "@grandvisionhq/graphql";
import { usePaymentsUIContext } from "@grandvisionhq/payments";
import { dispatchCartChangeEvent } from "../../../../hooks/carts/hooks/carts/use-cart-change-listener.js";
import { getUpdatedUrlWithQueryParams, appendQueryParamToUrl } from "../../../../utils/utils/get-updated-url-with-query-params.js";
import { recoverCheckout } from "../../../../pages/api/pages/api/recover-checkout.js";
const useHandleQrFormUpdates = ({
  qrPaymentConfig,
  selfUrl,
  paymentMethodType,
  paymentMethodLogos,
  orderDataToken,
  orderId,
  paymentFlow
}) => {
  const { cart, fetchByCartId } = Context.useCart();
  const { paymentQRCodeState } = usePaymentsUIContext();
  const apolloClient = useApolloClient();
  const { push } = useLocation();
  const { href: orderConfirmHref } = useLink({
    route: "order.confirm",
    params: {
      orderData: ""
    }
  }) || {};
  const updatedUrl = React.useCallback(
    (cartId, cartHash) => {
      const redirectUrl = getUpdatedUrlWithQueryParams({
        cartId,
        ...cartHash ? { cartHash } : {},
        type: paymentMethodType
      });
      push(redirectUrl);
    },
    [paymentMethodType, push]
  );
  const replicateCart = React.useCallback(
    (oldCartId) => {
      return recoverCheckout(apolloClient, oldCartId);
    },
    [apolloClient]
  );
  const refetch = React.useCallback(
    (cartId, cartHash) => {
      fetchByCartId(cartId, cartHash);
      dispatchCartChangeEvent(cartId);
      updatedUrl(cartId, cartHash);
    },
    [fetchByCartId, updatedUrl]
  );
  React.useEffect(() => {
    if (paymentQRCodeState === "Paid" && orderConfirmHref && orderDataToken) {
      push(
        appendQueryParamToUrl(orderConfirmHref, {
          cartId: cart?.id,
          orderData: orderDataToken
        })
      );
    }
  }, [cart?.id, paymentQRCodeState, orderConfirmHref, push, orderDataToken]);
  const qrCodeFormData = React.useMemo(() => {
    return {
      paymentMethodType,
      selfUrl,
      logoUrl: paymentMethodLogos && paymentMethodLogos[paymentMethodType]?.url,
      orderId,
      qrPaymentConfig,
      orderToken: orderDataToken,
      refetch,
      paymentFlow,
      getNewCart: replicateCart
    };
  }, [
    paymentMethodType,
    selfUrl,
    paymentMethodLogos,
    orderId,
    qrPaymentConfig,
    orderDataToken,
    refetch,
    paymentFlow,
    replicateCart
  ]);
  return [qrCodeFormData];
};
export {
  useHandleQrFormUpdates
};
//# sourceMappingURL=use-handle-qr-form-updates.js.map
